import React from 'react';
import './Posts.css';

/**
 * JobsList
 * Renders teaser cards for open roles, each linking out to a real job
 * board (LinkedIn Jobs, Indeed, We Work Remotely, etc.). These are
 * discovery teasers, not first-party job postings hosted on this site,
 * so we deliberately don't emit JobPosting JSON-LD here — that schema
 * is meant for a site's own listings with hiringOrganization/validThrough
 * details, and misusing it on outbound teasers risks Search Console
 * "Invalid structured data" flags. If IURIX starts hosting its own
 * postings, add JobPosting schema per listing at that point.
 */
const JobsList = ({ jobs = [] }) => {
  if (!jobs.length) {
    return (
      <div className='posts-container'>
        <p className='posts-empty'>No open roles listed right now — check back soon.</p>
      </div>
    );
  }

  return (
    <div className='posts-container'>
      <div className='posts-grid'>
        {jobs.map(job => (
          <article key={job.id} className='post-card glass-dark'>
            <div className='post-header'>
              <span className='post-category'>{job.location}</span>
              <span className='post-date'>via {job.source}</span>
            </div>
            <h3 className='post-title'>{job.role}</h3>
            <p className='post-excerpt'>{job.blurb}</p>
            <a
              href={job.url}
              className='post-link'
              target='_blank'
              rel='noopener noreferrer nofollow'
            >
              View on {job.source} ↗
            </a>
          </article>
        ))}
      </div>
    </div>
  );
};

export default JobsList;
